export const RESET = 'RESET_BROADCASTS'

export const GET_BROADCASTS = 'GET_BROADCASTS'
export const SET_BROADCASTS = 'SET_BROADCASTS'
export const SAVE_BROADCAST = 'SAVE_BROADCAST'
export const DELETE_BROADCAST = 'DELETE_BROADCAST'


